import { render } from "./HealthCenterFormComponent.vue?vue&type=template&id=89147518"
import script from "./HealthCenterFormComponent.vue?vue&type=script&lang=js"
export * from "./HealthCenterFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/kinarya-jqdev/jqdev/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__